import React, { useEffect, useRef, useState } from "react";
import { CircularProgress } from "@mui/material";
import styles from "../CalendarStyles.module.css";
import { useDispatch } from "react-redux";
import ResoucingWindow from "./ResourcingWindow";
import { getJobParentTasks, getShiftsMetadataResourcing } from "../../../../actions/v2/CalendarActions";
import { notification, Modal } from "antd";
import CloseIcon from '@mui/icons-material/Close';
import { Strings } from "../../../../dataProvider/localize";
import moment from "moment";
import v2Styles from "../../v2Styles.module.css";
import PlanJobShiftsModal from "./PlanJobShiftsModal";

export default function ShiftsResourcingModal(props) {

  const [loading, setLoading] = useState(false);
  const [tasks, setTasks] = useState([]);
  const dispatch = useDispatch();

  const [jobShifts, setJobShifts] = useState([]);
  // const [deletedShifts, setDeletedShifts] = useState([]);
  const [planShiftsModal, setPlanShiftsModal] = useState(false);
  const [editingPlanId, setEditingPlanId] = useState(null);
  const [jobDates, setJobDates] = useState({});

  const controller = useRef();

  const onEditShiftPlan = (planId) => {
    setEditingPlanId(planId);
    setPlanShiftsModal(true);
  }

  const getJobShiftsAndTasks = () => {
    setLoading(true);
    const requests = [];
    controller.current = new AbortController();

    requests.push(dispatch(getShiftsMetadataResourcing(props.job.job_id)))
    requests.push(dispatch(getJobParentTasks({ signal: controller.current.signal }, { job_id: props.job.job_id })))
    Promise.all(requests).then(([res, res2]) => {
      if (res.length > 0) {
        let shifts = [...res].map(x => {
          let end_hour = moment.utc(x.shift_finish_time).minutes(0)
          if (moment(end_hour).format("HH:mm") === "00:00") {
            moment(end_hour).subtract(1, "minute");
          }
          return ({
            id: x.id,
            job_id: x.job_id,
            staffs: x.no_of_staffs,
            supervisors: x.no_of_supervisors,
            start_date: moment.utc(x.shift_start_time).format("YYYY-MM-DD"),
            start_time: moment.utc(x.shift_start_time).format("HH:mm"),
            visual_start_time: moment.utc(x.shift_start_time).format("HH:00"),
            end_date: moment.utc(x.shift_finish_time).format("YYYY-MM-DD"),
            end_time: moment(end_hour).format("HH:mm"),
            dateStamp: moment.utc(x.shift_start_time).startOf("day").unix(),
            duration: moment.utc(x.shift_finish_time).diff(x.shift_start_time, "hours"),
            startGap: moment.utc(x.shift_start_time).diff(moment.utc(x.shift_start_time).startOf("day"), "hours"),
            quote_task_id: x.quote_task_id,
            shift_start_time: x.shift_start_time,
            shift_plan: x.shift_plan,
            shift_finish_time: x.shift_finish_time,
            shift_status: x.shift_status,
            shift_id: x.shift_id ? x.shift_id : null,
            resourcing_status: x.resourcing_status
          })
        })
        setJobShifts(shifts);
      } else {
        setJobShifts([]);
      }
      if (res2 && res2.tasks && res2.tasks.length > 0) {
        let allTasks = res2.tasks.map(x => ({ id: x.taskId, task_name: x.jobTaskLabel }));
        setTasks(allTasks);
        if (res2 && res2.job_start_date && res2.job_end_date) {
          setJobDates({
            job_start_date: res2.job_start_date,
            job_end_date: res2.job_end_date
          })
        }
      } else {
        setTasks([]);
        setJobDates({
        })
      }
      setLoading(false)

    }).catch(err => {
      if (err) {
        notification.error({
          message: Strings.error_title,
          description: err ? err : "There was an error while getting Job Shifts.",
          className: "ant-error"
        });
        setLoading(false)
      }
    })
  }

  useEffect(() => {
    if (props.job) {
      getJobShiftsAndTasks();
    }
    return () => {
      if (controller.current) {
        controller.current.abort();
      }
    }
  }, [])

  // const onCreateUpdateJob = () => {
  //   let formData = { ...props.jobData };
  //   formData.shift_resourcing_data = [...jobShifts].map(shift => ({
  //     ...(shift.id ? { id: shift.id } : {}),
  //     quote_task_id: shift.quote_task_id,
  //     no_of_supervisors: shift.supervisors,
  //     no_of_staffs: shift.staffs,
  //     shift_start_time: shift.shift_start_time ? shift.shift_start_time : `${shift.start_date} ${shift.start_time}`,
  //     shift_finish_time: shift.shift_finish_time ? shift.shift_finish_time : `${shift.start_date} ${shift.end_time}`,
  //   }));
  //   let allTasks = props.jobData.jobs_data.map(x => moment(x.start_date).unix()).sort((a, b) => a - b);
  //   let jobStart = moment.unix(allTasks[0]).format("YYYY-MM-DD");
  //   let deleted = deletedShifts.map(x => x.id);
  //   let shiftsDeleted = deletedShifts.map(x => x.shift_id).filter(x => x !== null);
  //   formData.deleted_shifts = JSON.stringify(shiftsDeleted);
  //   if (formData.contract_id && formData.contract_id === "no_contract") {
  //     formData.contract_id = null;
  //   }
  //   formData.deleted_shifts_resources = JSON.stringify(deleted);
  //   formData.jobs_data = JSON.stringify(props.jobData.jobs_data);
  //   setLoading(true);
  //   dispatch(createUpdateCalendarJob(formData)).then(message => {
  //     notification.success({
  //       message: Strings.success_title,
  //       description: message,
  //       className: "ant-success"
  //     });
  //     props.onSubmitClose(jobStart, true);
  //   }).catch(err => {
  //     notification.error({
  //       message: Strings.error_title,
  //       description: err ? err : Strings.generic_error,
  //       className: "ant-error"
  //     })
  //   }).finally(() => {
  //     setLoading(false)
  //   })
  // }

  return (
    <div>
      {loading ?
        <div className="d-flex justify-content-center">
          <CircularProgress size={20} />
        </div> : (
          <div className="container-fluid">
            <div className="row align-items-center">
              <div className="col-9">
                <div className={styles.ModalHeading}>{props.job ? `Manage Shifts - ${props.job.name}` : "Manage Shifts"}</div>
              </div>
              <div className="col-3 text-right">
                <button disabled={loading} onClick={() => setPlanShiftsModal(true)} className={`${v2Styles.PrimaryButton} mt-2`}>Plan Shifts</button>
              </div>
            </div>
            <div className="row">
              <div className="col-12">
                <ResoucingWindow job={props.job} dates={jobDates} shifts={jobShifts} onEditPlan={onEditShiftPlan} refreshShifts={getJobShiftsAndTasks} />
              </div>
            </div>
            {/* <div className="row">
              <div className="col-12 py-2">
                <div className="d-flex align-items-center justify-content-center">
                  <div className="px-1">
                    <button
                      type="button"
                      disabled={jobShifts.length === 0 || loading}
                      onClick={onCreateUpdateJob}
                      className={`${styles.FilterButton} ${jobShifts.length === 0 || loading ? styles.DisabledButton : ""}`}>
                      {props.job ? "Update" : "Create Job"}
                    </button>
                  </div>
                  <div className="px-1">
                    <button onClick={props.onClose} className={`${styles.ResetButton} ${loading ? styles.DisabledResetButton : ""}`} disabled={loading}>Cancel</button>
                  </div>
                </div>
              </div>
            </div> */}
          </div>
        )}
      <Modal
        className="cs-modal-v2"
        centered
        footer={null}
        visible={planShiftsModal}
        maskClosable={false}
        onCancel={() => setPlanShiftsModal(false)}
        afterClose={() => { getJobShiftsAndTasks(); setEditingPlanId(null) }}
        width={"60vw"}
        destroyOnClose={true}
        bodyStyle={{ paddingRight: "0px", paddingLeft: "0px" }}
        closeIcon={<div className={styles.ModalCloseIcon}><CloseIcon /></div>}>
        <PlanJobShiftsModal refreshShifts={getJobShiftsAndTasks} editingPlanId={editingPlanId} job={props.job} tasks={tasks} loading={loading} onClose={() => { setPlanShiftsModal(false) }} />
      </Modal>
    </div>
  )
}